"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateBuilderConfig = exports.getAddressComponent = void 0;
const luxon_1 = require("luxon");
const event_1 = require("../event");
const location_1 = require("../location");
const utils_1 = require("../utils");
const luxify = (t) => typeof t.toDate === "function"
    ? luxon_1.DateTime.fromJSDate(t.toDate())
    : luxon_1.DateTime.utc().minus({ year: 100 });
const getAddressComponent = (types, components) => {
    var _a;
    let result = "";
    if (typeof types === "string") {
        types = [types];
    }
    for (const type of types) {
        if (!result) {
            result =
                ((_a = components === null || components === void 0 ? void 0 : components.find(({ types }) => types.includes(type))) === null || _a === void 0 ? void 0 : _a.short_name) || "";
        }
    }
    return result;
};
exports.getAddressComponent = getAddressComponent;
const getPreRegCard = (cards) => {
    return cards === null || cards === void 0 ? void 0 : cards.find((c) => {
        if (c.visible && !c.visible.hide) {
            const states = (0, event_1.getVisibilityRuleStates)(c.visible);
            if (states.includes(event_1.UserEventStates.draft)) {
                return true;
            }
        }
        return false;
    });
};
const getPostRegCard = (cards) => {
    return cards === null || cards === void 0 ? void 0 : cards.find((c) => {
        var _a;
        if ((_a = c.visible) === null || _a === void 0 ? void 0 : _a.hide) {
            const states = (0, event_1.getVisibilityRuleStates)(c.visible);
            if (states.includes(event_1.UserEventStates.draft)) {
                return true;
            }
        }
        return false;
    });
};
const eventTypes = Object.keys(event_1.EventTypes).filter((v) => !isNaN(Number(v)));
const generateBuilderConfig = (event, builder, concerts, langs) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13, _14, _15, _16, _17, _18, _19, _20;
    const config = Object.assign({}, builder);
    /**
     * Utility function to build `TranslatableContent` for all event config
     */
    const i18n = (getContent) => {
        const events = [
            ["en", event],
            ...Object.entries(langs || {}),
        ];
        return Object.fromEntries(events.map(([language, event]) => [language, getContent(event)]));
    };
    const i18nDupe = (value) => Object.fromEntries(["en", ...Object.keys(langs || {})].map((language) => [language, value]));
    /* ---------------------
      Show Details
    --------------------- */
    config.fields.startTime = { content: event.config.header.date };
    const isEstablishment = (((_b = (_a = event.root) === null || _a === void 0 ? void 0 : _a.geocode) === null || _b === void 0 ? void 0 : _b.types) || []).findIndex((type) => location_1.GOOGLE_PLACES_ESTABLISHMENT_TYPES.includes(type)) !== -1;
    const matchedConcert = 
    // First, try exact ID match
    (concerts === null || concerts === void 0 ? void 0 : concerts.find((c) => { var _a, _b; return c.id === ((_b = (_a = builder.fields.concert) === null || _a === void 0 ? void 0 : _a.content) === null || _b === void 0 ? void 0 : _b.id); })) ||
        (
        // Fallback to checking date
        concerts === null || concerts === void 0 ? void 0 : concerts.find((c) => !!c.date &&
            event.config.header.date &&
            luxify(c.date).toISODate() ===
                luxify(event.config.header.date).toISODate()));
    config.fields.concert = {
        content: matchedConcert || {
            address: event.config.header.location || "",
            addressType: isEstablishment ? "establishment" : "address",
            coords: [
                ((_d = (_c = event.root) === null || _c === void 0 ? void 0 : _c.coordinates) === null || _d === void 0 ? void 0 : _d.latitude) || 0,
                ((_f = (_e = event.root) === null || _e === void 0 ? void 0 : _e.coordinates) === null || _f === void 0 ? void 0 : _f.longitude) || 0,
            ],
            date: event.config.header.date,
            geocode: event.root.geocode,
            locationAddedManually: true,
            source: "manual",
            timeZone: (_g = event.root) === null || _g === void 0 ? void 0 : _g.timeZoneName,
            venue: event.config.header.venue || "",
            // Address Components
            city: (0, exports.getAddressComponent)(["locality", "sublocality", "sublocality_level_1"], (_h = event.root.geocode) === null || _h === void 0 ? void 0 : _h.address_components),
            state: (0, exports.getAddressComponent)("administrative_area_level_1", (_j = event.root.geocode) === null || _j === void 0 ? void 0 : _j.address_components),
            zip: (0, exports.getAddressComponent)("postal_code", (_k = event.root.geocode) === null || _k === void 0 ? void 0 : _k.address_components),
            country: (0, exports.getAddressComponent)("country", (_l = event.root.geocode) === null || _l === void 0 ? void 0 : _l.address_components),
            id: Math.random().toString(36).substring(2),
            // do these fields need to be set?
            title: "",
            venue_id: "",
            updated_at: 0,
            artists: [],
            deletedAt: null,
        },
    };
    /* ---------------------
      Appearance
    --------------------- */
    config.fields = {
        ...config.fields,
        // Selected Template Type
        type: { content: event.config.type },
        // Selected Event Image
        image: { content: event.config.header.image },
    };
    /*  Color Palette
    --------------------- */
    config.fields.colors = {
        content: [
            eventTypes.reduce((t, v, i) => {
                if (event.config.colors) {
                    t[i] = event.config.colors;
                }
                else {
                    throw new Error("Invalid color config");
                }
                return t;
            }, {}),
        ].concat(((_m = config.fields.colors) === null || _m === void 0 ? void 0 : _m.content) || []),
    };
    /*  Root Image Collection
    --------------------- */
    const matchImageIndex = (_o = builder.images) === null || _o === void 0 ? void 0 : _o.findIndex((img) => img.src.includes(event.config.header.image));
    if (matchImageIndex > -1) {
        config.images[matchImageIndex].templates.map((t) => ({
            ...t,
            colorsOptions: [event.config.colors, ...t.colorsOptions],
        }));
    }
    else {
        const colors = event.config.colors;
        if (!colors) {
            throw new Error("Malformed color configuration");
        }
        config.images.unshift({
            src: event.config.header.image,
            templates: eventTypes.map((t, i) => ({
                type: i,
                colorsOptions: [colors],
            })),
        });
    }
    /* ---------------------
      Pre-Registration
    --------------------- */
    const preRegEn = getPreRegCard(event.config.cards);
    config.fields = {
        ...config.fields,
        registerTitle: { content: i18n((e) => { var _a; return ((_a = e.config.register) === null || _a === void 0 ? void 0 : _a.title) || ""; }) },
        registerSubtitle: {
            content: i18n((e) => { var _a; return ((_a = e.config.register) === null || _a === void 0 ? void 0 : _a.subtitle) || ""; }),
        },
        registerCtaLabel: {
            content: i18n((e) => { var _a; return ((_a = e.config.register) === null || _a === void 0 ? void 0 : _a.ctalabel) || ""; }),
        },
        preRegistrationHeadline: {
            content: i18n((e) => { var _a; return ((_a = getPreRegCard(e.config.cards)) === null || _a === void 0 ? void 0 : _a.headline) || ""; }),
        },
        preRegistrationButtonLabel: {
            content: i18n((e) => { var _a; return ((_a = getPreRegCard(e.config.cards)) === null || _a === void 0 ? void 0 : _a.ctalabel) || (preRegEn === null || preRegEn === void 0 ? void 0 : preRegEn.ctalabel) || ""; }),
        },
    };
    /*  Check In
    --------------------- */
    if (!((_p = preRegEn === null || preRegEn === void 0 ? void 0 : preRegEn.songs) === null || _p === void 0 ? void 0 : _p.length)) {
        config.fields = {
            ...config.fields,
            checkInVote: { content: "checkin" },
            preRegistrationBody: {
                content: i18n((e) => { var _a; return ((_a = e.config.cards) === null || _a === void 0 ? void 0 : _a[0].body) || ""; }),
            },
        };
    }
    /*  Vote
    --------------------- */
    if (!!((_q = preRegEn === null || preRegEn === void 0 ? void 0 : preRegEn.songs) === null || _q === void 0 ? void 0 : _q.length)) {
        const voteType = preRegEn.songs.findIndex((s) => s.album) === -1 ? "vote" : "song";
        config.fields = {
            ...config.fields,
            checkInVote: { content: "vote" },
            voteType: { content: voteType },
            preRegistrationSubtitle: {
                content: i18n((e) => { var _a; return ((_a = e.config.cards) === null || _a === void 0 ? void 0 : _a[0].subtitle) || ""; }),
            },
        };
        if (voteType === "song") {
            config.fields.songOptions = {
                content: preRegEn.songs.map((s) => ({
                    name: s.title,
                    album: s.album || "",
                })),
            };
        }
        else {
            config.fields.voteOptions = {
                content: preRegEn.songs.map((_, i) => i18n((e) => { var _a, _b; return ((_b = (_a = getPreRegCard(e.config.cards)) === null || _a === void 0 ? void 0 : _a.songs) === null || _b === void 0 ? void 0 : _b[i].title) || ""; })),
            };
        }
    }
    /*  Privacy Policies
    --------------------- */
    config.fields = {
        ...config.fields,
        privacyPolicyConfirm: { content: true },
    };
    if ((_s = (_r = event.config.register) === null || _r === void 0 ? void 0 : _r.optIns) === null || _s === void 0 ? void 0 : _s.artist) {
        config.fields.privacyPolicies = {
            content: [
                {
                    entity: "artist",
                    name: event.root.artistName || "",
                    url: (_u = (_t = event.config.register) === null || _t === void 0 ? void 0 : _t.optIns) === null || _u === void 0 ? void 0 : _u.artist,
                    isSeparate: false,
                    source: "SET.Admin",
                },
            ],
        };
    }
    if ((_w = (_v = event.config.register) === null || _v === void 0 ? void 0 : _v.optIns) === null || _w === void 0 ? void 0 : _w.entities) {
        config.fields.privacyPolicies = {
            content: (((_x = config.fields.privacyPolicies) === null || _x === void 0 ? void 0 : _x.content) || []).concat(event.config.register.optIns.entities.map((e) => ({
                entity: "other",
                name: e.entityName,
                url: e.url,
                isSeparate: false,
                source: "SET.Admin",
            }))),
        };
    }
    /*  Sweepstakes
    --------------------- */
    if ((_y = event.config.register) === null || _y === void 0 ? void 0 : _y.hasSweepstakes) {
        config.fields = {
            ...config.fields,
            sweepstakes: { content: true },
            //! fields not populated
            sweepstakesPrize: { content: "customPrize" },
            sweepstakesPrizeTerms: { content: true },
            sweepstakesPrizeCustom: { content: i18nDupe("(Described in copy)") },
        };
    }
    else {
        config.fields.sweepstakes = { content: false };
    }
    /* ---------------------
      Post-Registration
    --------------------- */
    const postRegEn = getPostRegCard(event.config.cards);
    const postRegType = (postRegEn === null || postRegEn === void 0 ? void 0 : postRegEn.cta) === "social"
        ? "promo"
        : ((_z = postRegEn === null || postRegEn === void 0 ? void 0 : postRegEn.cta) === null || _z === void 0 ? void 0 : _z.includes("http"))
            ? "link"
            : "thank";
    config.fields = {
        ...config.fields,
        postRegistration: { content: postRegType },
        postRegistrationHeadline: {
            content: i18n((e) => { var _a; return ((_a = getPostRegCard(e.config.cards)) === null || _a === void 0 ? void 0 : _a.headline) || ""; }),
        },
        postRegistrationBody: {
            content: i18n((e) => { var _a; return ((_a = getPostRegCard(e.config.cards)) === null || _a === void 0 ? void 0 : _a.body) || ""; }),
        },
    };
    const makeHttps = (url) => {
        if (url) {
            url = (url.startsWith("http") ? url : `https://${url}`).replace(/^http:/, "https:");
        }
        return url;
    };
    /*  Promote Release
    --------------------- */
    if (postRegType === "promo") {
        const release = {
            content: {
                releaseId: Math.random().toString(36).substring(2),
                image: (postRegEn === null || postRegEn === void 0 ? void 0 : postRegEn.image) || "",
                name: "", //! unable to populate field from data
                type: "album", //! unable to populate field from data
                appleMusic: makeHttps((_0 = event.config.social) === null || _0 === void 0 ? void 0 : _0.apple) || "",
                amazon: makeHttps((_1 = event.config.social) === null || _1 === void 0 ? void 0 : _1.amazon) || "",
                deezer: makeHttps((_2 = event.config.social) === null || _2 === void 0 ? void 0 : _2.deezer) || "",
                iHeartRadio: makeHttps((_3 = event.config.social) === null || _3 === void 0 ? void 0 : _3.iHeartRadio) || "",
                pandora: makeHttps((_4 = event.config.social) === null || _4 === void 0 ? void 0 : _4.pandora) || "",
                spotify: makeHttps((_5 = event.config.social) === null || _5 === void 0 ? void 0 : _5.spotify) || "",
                tidal: makeHttps((_6 = event.config.social) === null || _6 === void 0 ? void 0 : _6.tidal) || "",
                youtubeMusic: makeHttps((_7 = event.config.social) === null || _7 === void 0 ? void 0 : _7.youtube) || "",
            },
        };
        config.fields = {
            ...config.fields,
            postRegistrationAlbum: release,
            postRegistrationCustomAlbum: release,
            postRegistrationButtonLabel: {
                content: i18n((e) => {
                    var _a;
                    return ((_a = getPostRegCard(e.config.cards)) === null || _a === void 0 ? void 0 : _a.ctalabel) ||
                        (postRegEn === null || postRegEn === void 0 ? void 0 : postRegEn.ctalabel) ||
                        "";
                }),
            },
        };
    }
    /*  Custom Link
    --------------------- */
    if (postRegType === "link") {
        config.fields = {
            ...config.fields,
            postRegistrationLinkLabel: {
                content: i18n((e) => {
                    var _a;
                    return ((_a = getPostRegCard(e.config.cards)) === null || _a === void 0 ? void 0 : _a.ctalabel) ||
                        (postRegEn === null || postRegEn === void 0 ? void 0 : postRegEn.ctalabel) ||
                        "";
                }),
            },
            postRegistrationLinkUrl: { content: (postRegEn === null || postRegEn === void 0 ? void 0 : postRegEn.cta) || "" },
        };
    }
    /* ---------------------
      Social URLs
    --------------------- */
    config.fields = {
        ...config.fields,
        socialLinkFacebook: { content: ((_8 = event.config.socialLinks) === null || _8 === void 0 ? void 0 : _8.facebook) || "" },
        socialLinkInstagram: { content: ((_9 = event.config.socialLinks) === null || _9 === void 0 ? void 0 : _9.instagram) || "" },
        socialLinkShazam: { content: ((_10 = event.config.socialLinks) === null || _10 === void 0 ? void 0 : _10.shazam) || "" },
        socialLinkSpotify: { content: ((_11 = event.config.socialLinks) === null || _11 === void 0 ? void 0 : _11.spotify) || "" },
        socialLinkTiktok: { content: ((_12 = event.config.socialLinks) === null || _12 === void 0 ? void 0 : _12.tiktok) || "" },
        socialLinkTwitter: { content: ((_13 = event.config.socialLinks) === null || _13 === void 0 ? void 0 : _13.twitter) || "" },
        socialLinkYoutube: { content: ((_14 = event.config.socialLinks) === null || _14 === void 0 ? void 0 : _14.youtube) || "" },
    };
    /* ---------------------
      Merch
    --------------------- */
    const merchCard = (_15 = event.config.cards) === null || _15 === void 0 ? void 0 : _15.find((c) => { var _a; return !!((_a = c.merch) === null || _a === void 0 ? void 0 : _a.length); });
    if (((_16 = merchCard === null || merchCard === void 0 ? void 0 : merchCard.merch) === null || _16 === void 0 ? void 0 : _16.length) && ((_18 = (_17 = builder.fields.merchandise) === null || _17 === void 0 ? void 0 : _17.content) === null || _18 === void 0 ? void 0 : _18.length)) {
        /* Remap merch items */
        const eventMerch = merchCard.merch.map((m) => ({
            img: m.photo || "",
            text: m.name || "",
            url: m.url || "",
            id: Math.random().toString(36).substring(2),
            isSelected: false,
        }));
        /* Find and merge matching merch items */
        const builderMerch = [...builder.fields.merchandise.content].map((m) => {
            const merchMatch = eventMerch.find(({ url }) => url === m.url);
            return {
                ...(merchMatch || m),
                id: m.id,
            };
        });
        /* Filter duplicate items */
        const filteredMerch = eventMerch.filter((m) => (builderMerch === null || builderMerch === void 0 ? void 0 : builderMerch.findIndex((c) => c.url === m.url)) === -1);
        config.fields.merchandise = {
            content: builderMerch
                .concat(filteredMerch)
                .map((m, i) => ({ ...m, isSelected: !(i > 3) })),
        };
    }
    /* ---------------------
      Post show email custom from
    --------------------- */
    if ((_19 = event.config.customPostShowEmail) === null || _19 === void 0 ? void 0 : _19.from) {
        config.customPostShowEmail = { ...event.config.customPostShowEmail };
    }
    else {
        config.customPostShowEmail = {
            from: `${((_20 = config.fields.displayedName) === null || _20 === void 0 ? void 0 : _20.content) || event.root.artistName} and SET.Live`,
        };
    }
    /**
     * Custom Register
     */
    if (event.config.register) {
        config.customRegister = {
            en: event.config.register,
        };
        for (const lang of (0, utils_1.enumKeys)(langs)) {
            if (langs === null || langs === void 0 ? void 0 : langs[lang].config.register) {
                config.customRegister[lang] = langs === null || langs === void 0 ? void 0 : langs[lang].config.register;
            }
        }
    }
    return config;
};
exports.generateBuilderConfig = generateBuilderConfig;
//# sourceMappingURL=generateBuilderConfig.js.map